// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingIcon_root__11zuI","icon_wrapper":"BookingIcon_icon_wrapper__k6UCc"};